import React from "react";
import { appStore } from "@/app_store";
import { container } from "@/utils/mobx";
import { DashboardSectionStore } from "./store";
import { FileBrowser } from "@/components/FileBrowser";
import { t } from "@/i18n";
import "./s.dashboard_section.css";


export const DashboardSection = container((props: {
    store: DashboardSectionStore;
}) => {
    const store = props.store;

    return (
        <div className="dashboard_section">
            <div className="dashboard_section__inner">
                <div className="dashboard_section__title">{t("dashboard_title")}</div>
                {store.projects.length === 0 ? (
                    <div className="dashboard_section__empty">{t("dashboard_empty")}</div>
                ) : (
                    <div className="dashboard_section__list">
                        {store.projects.map(project => (
                            <button
                                key={project.id}
                                className="dashboard_section__project"
                                onClick={() => store.selectProject(project.id)}
                            >
                                <span className="dashboard_section__project_name">{project.name}</span>
                            </button>
                        ))}
                    </div>
                )}
                {appStore.agent.isConnected && <div className="dashboard_section__file_browser">
                    <FileBrowser
                        rootPath=""
                        sandbox={appStore.agent.session.root_sandbox}
                        onSelect={(path, isDir) => store.onFileBrowserSelect(path, isDir)}
                    />
                    {store.selectedIsDir && (
                        <button
                            className="dashboard_section__open_project_btn"
                            onClick={() => store.openSelectedAsProject()}
                        >
                            {t("dashboard_open_project")}
                        </button>
                    )}
                </div>}
            </div>
        </div>
    );
}, DashboardSectionStore);
